import { createAction } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { UserSlim } from '../../types/account/UserSlim';

const request = createAction(
    'entities/clo-manager-users/REQUEST',
    resolve => (requestState: RequestState) => resolve({ requestState }),
);

const response = createAction(
    'entities/clo-manager-users/RESPONSE',
    resolve => (requestState: RequestState, users: UserSlim[]) => resolve({ requestState, users }),
);

export const cloManagerUsersActions = { request, response };
